import { useState } from 'react';
import { Play } from 'lucide-react';
import { getVideoEmbedUrl, parseDuration } from '@shared/services/youtube';
import type { VideoResult } from '@shared/types/learning-path';

interface TutorVideoResultsProps {
  videos: VideoResult[];
}

export function TutorVideoResults({ videos }: TutorVideoResultsProps) {
  const [playingId, setPlayingId] = useState<string | null>(null);

  return (
    <div className="mt-3 space-y-2">
      {videos.map((video) => (
        <div key={video.videoId} className="rounded-lg bg-dark-subtle border border-dark-border overflow-hidden">
          {playingId === video.videoId ? (
            <div className="aspect-video">
              <iframe
                src={getVideoEmbedUrl(video.videoId)}
                title={video.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <button
              onClick={() => setPlayingId(video.videoId)}
              className="w-full flex items-center gap-3 p-3 text-left cursor-pointer hover:bg-dark-hover transition-colors"
            >
              <div className="w-10 h-10 rounded bg-indigo-500/20 flex items-center justify-center shrink-0">
                <Play size={14} className="text-indigo-400 ml-0.5" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-content font-body font-medium truncate">{video.title}</p>
                <p className="text-[10px] text-content-muted font-body">
                  {video.channelName} · {video.duration ? parseDuration(video.duration) : ''}
                </p>
              </div>
            </button>
          )}
          {video.relevanceNote && (
            <p className="px-3 pb-2 text-[10px] text-content-dim font-body italic">{video.relevanceNote}</p>
          )}
        </div>
      ))}
    </div>
  );
}
